<!-- Раздел Communication доступен только по backend pages_access. -->
<template>
  <li
    v-if="canSeePage('communication_posts')"
    class="nav-item"
    :class="{ active: activeItem === 'communication_posts' }"
  >
    <router-link
      :to="{ name: 'CommunicationPosts' }"
      :title="collapsed ? 'Коммуникация' : ''"
      class="communication-nav-link"
      :class="{ 'communication-nav-link--collapsed': collapsed }"
    >
      <div class="link-icon_box">
        <AppIcon class="communication-sidebar-icon" name="megaphone" :size="24" />
      </div>
      <span v-if="!collapsed" class="nav-link">Коммуникация</span>
    </router-link>
  </li>
</template>
<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
export default {
  name: "AppSidebarCommunicationItem",
  components: { AppIcon },
  props: {
    collapsed: Boolean,
    activeItem: { type: String, default: "" },
    canSeePage: { type: Function, required: true },
  },
};
</script>
<style scoped>
.communication-nav-link {
  display: flex;
  align-items: center;
  width: 100%;
  color: inherit;
  text-decoration: none;
}
.communication-nav-link--collapsed {
  justify-content: center;
}
.communication-sidebar-icon :deep(path) {
  fill: var(--color-green);
  stroke: var(--color-green);
}
</style>
